"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RenderingObject_1 = require("../myLib/webgl/engine/RenderingObject");
var VertexAttributeObject_1 = require("../myLib/webgl/engine/VertexAttributeObject");
/**
 * @author Kentaro Kawakatsu
 */
var TransformFeedbackVertex = /** @class */ (function (_super) {
    __extends(TransformFeedbackVertex, _super);
    function TransformFeedbackVertex($context, $numParticles) {
        var _this = _super.call(this, $context) || this;
        _this.context2 = $context;
        _this.numParticles = $numParticles;
        _this.setData();
        return _this;
    }
    TransformFeedbackVertex.prototype.setData = function () {
        var vertexIDList = [];
        var positionList = [];
        var velocityList = [];
        var birthList = [];
        for (var i = 0; i < this.numParticles; i++) {
            vertexIDList[i] = i;
            positionList[i * 3] = 0;
            positionList[i * 3 + 1] = 0;
            positionList[i * 3 + 2] = 0;
            velocityList[i * 3] = 0;
            velocityList[i * 3 + 1] = 0;
            velocityList[i * 3 + 2] = 0;
            birthList[i] = 0;
        }
        this.positionList = positionList;
        this.velocityList = velocityList;
        this.vertexIDList = vertexIDList;
        this.birthList = birthList;
        var attribute;
        attribute = new VertexAttributeObject_1.VertexAttributeObject("vertexID");
        attribute.buffer = this.context.createBuffer();
        this.vboList.push(attribute);
        this.context.bindBuffer(this.context.ARRAY_BUFFER, attribute.buffer);
        this.context.bufferData(this.context.ARRAY_BUFFER, new Float32Array(vertexIDList), this.context.STATIC_DRAW);
        attribute = new VertexAttributeObject_1.VertexAttributeObject("position");
        attribute.buffer = this.context.createBuffer();
        this.vboList.push(attribute);
        this.context.bindBuffer(this.context.ARRAY_BUFFER, attribute.buffer);
        this.context.bufferData(this.context.ARRAY_BUFFER, new Float32Array(positionList), this.context2.STREAM_COPY);
        attribute = new VertexAttributeObject_1.VertexAttributeObject("velocityTotal");
        attribute.buffer = this.context.createBuffer();
        this.vboList.push(attribute);
        this.context.bindBuffer(this.context.ARRAY_BUFFER, attribute.buffer);
        this.context.bufferData(this.context.ARRAY_BUFFER, new Float32Array(velocityList), this.context2.STREAM_COPY);
        attribute = new VertexAttributeObject_1.VertexAttributeObject("birth");
        attribute.buffer = this.context.createBuffer();
        this.vboList.push(attribute);
        this.context.bindBuffer(this.context.ARRAY_BUFFER, attribute.buffer);
        this.context.bufferData(this.context.ARRAY_BUFFER, new Float32Array(birthList), this.context2.STREAM_COPY);
        this.context.bindBuffer(this.context.ARRAY_BUFFER, null);
    };
    TransformFeedbackVertex.prototype.bindBufferBase = function () {
        var context2 = this.context;
        var shader2 = this.shader;
        var length = shader2.transformFeedbackVaryingList.length;
        for (var i = 0; i < length; i++) {
            var varying = shader2.transformFeedbackVaryingList[i];
            var vbo = this.getTransformFeedbackVertexBuffer(varying.name);
            context2.bindBufferBase(context2.TRANSFORM_FEEDBACK_BUFFER, varying.location, vbo.buffer);
        }
    };
    TransformFeedbackVertex.prototype.unbindBufferBase = function () {
        var shader2 = this.shader;
        var length = shader2.transformFeedbackVaryingList.length;
        for (var i = 0; i < length; i++) {
            var varying = shader2.transformFeedbackVaryingList[i];
            this.context2.bindBufferBase(this.context2.TRANSFORM_FEEDBACK_BUFFER, varying.location, null);
        }
    };
    TransformFeedbackVertex.prototype.getTransformFeedbackVertexBuffer = function (varyingName) {
        var attribute;
        if (varyingName === "vPosition") {
            attribute = this.getVertexBuffer("position");
        }
        else if (varyingName === "vVelocityTotal") {
            attribute = this.getVertexBuffer("velocityTotal");
        }
        else if (varyingName === "vBirth") {
            attribute = this.getVertexBuffer("birth");
        }
        return attribute;
    };
    return TransformFeedbackVertex;
}(RenderingObject_1.RenderingObject));
exports.TransformFeedbackVertex = TransformFeedbackVertex;



//////////////////
// WEBPACK FOOTER
// ./src/ts/project/TransformFeedbackVertex.ts
// module id = 24
// module chunks = 0